import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles({
  wrenchFade: ({ transitionTime }) => ({
    '&$enter, &$exit': {
      transition: `opacity ${transitionTime}ms linear`,
    },
  }),
  enter: { opacity: '0' },
  enterActive: { opacity: '1' },
  exit: { opacity: '1' },
  exitActive: { opacity: '0' },
});

export default useStyles;
